import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import OutlookCalendar from './icon-outlook-calendar.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <OutlookCalendar {...validProps} />;
}
SvgComponent.iconName = 'outlookCalendar';

export const OutlookCalendarIcon = svgIconWrapper(SvgComponent);
